import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import App from './app/root';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { LicenseInfo } from '@mui/x-data-grid-pro';

const container = document.getElementById('root');
const root = createRoot(container);

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_DATAGRID_PRO);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
